import { createRouter, createWebHistory } from 'vue-router'
import Page404 from './views/Page404'
import Private from './layouts/Private'
import Public from './layouts/Public'
import CompaniesDashboards from './views/CompaniesDashboards.vue'
import CompaniesReviews from './views/CompaniesReviews.vue'
import CompaniesPhotos from './views/CompaniesPhotos.vue'
import CompaniesNotifications from './views/CompaniesNotifications.vue'
import CompaniesNotification from './views/CompaniesNotification.vue'
import RegistrationsInfo from './views/RegistrationsInfo'
import RegistrationsApplyCompleted from './views/RegistrationsApplyCompleted'
import CompaniesLocationStores from './views/CompaniesLocationStores.vue'
import CompaniesLocationStoresBulkEdit from './views/companies/location/stores/BulkEdit.vue'
import CompaniesLocationStoresBulkUpdateWithGmb from './views/companies/location/stores/BulkUpdateWithGmb.vue'
import CompaniesLocationStoresBulkUpdateInGmb from './views/companies/location/stores/BulkUpdateInGmb.vue'
import CompaniesLocationStoresBulkEditStoreOptions from './views/companies/location/stores/BulkEditStoreOptions.vue'
import CompaniesLocationStoreNew from './views/CompaniesLocationStoreNew.vue'
import CompaniesLocationStore from './views/CompaniesLocationStore.vue'
import CompaniesLocationStoreEdit from './views/CompaniesLocationStoreEdit.vue'
import CompaniesLocationStoreAttributesEdit from './views/companies/location/store/attributes/Edit.vue'
import CompaniesLocationStoreAttributesUrlEdit from './views/companies/location/store/attributes/UrlEdit.vue'
import CompaniesLocationStoreAttributesMultipleUrlEdit from './views/companies/location/store/attributes/MultipleUrlEdit.vue'
import CompaniesLocationStorePlaceActionLinksFoodorderingsEdit from './views/companies/location/store/placeActionLinks/Foodorderings.vue'
import CompaniesLocationStorePaymentMethodsEdit from './views/CompaniesLocationStorePaymentMethodsEdit.vue'
import CompaniesLocationStoreRegularHoursEdit from './views/CompaniesLocationStoreRegularHoursEdit.vue'
import CompaniesLocationStoreCategoriesEdit from './views/CompaniesLocationStoreCategoriesEdit.vue'
import CompaniesLocationStoreCompetitor from './views/CompaniesLocationStoreCompetitor.vue'
import CompaniesLocationStoreGmbInfosEdit from './views/CompaniesLocationStoreGmbInfosEdit.vue'
import CompaniesLocationStoreMediaLibrary from './views/CompaniesLocationStoreMediaLibrary.vue'
import CompaniesLocationStoreMediaLibraryUpload from './views/CompaniesLocationStoreMediaLibraryUpload.vue'
import CompaniesLocationStoreMediaLibraries from './views/CompaniesLocationStoreMediaLibraries.vue'
import CompaniesLocationStoreProduct from './views/CompaniesLocationStoreProduct.vue'
import CompaniesStorePostsIndex from './views/CompaniesStorePostsIndex.vue'
import CompaniesStorePostsForm from './views/CompaniesStorePostsForm.vue'
import CompaniesStoreSnsPostsIndex from './views/CompaniesStoreSnsPostsIndex.vue'
import CompaniesStoreSnsPostsForm from './views/CompaniesStoreSnsPostsForm.vue'
import CompaniesSurveys from './views/CompaniesSurveys.vue'
import CompaniesCompetitorsReviews from './views/CompaniesCompetitorsReviews.vue'
import CompaniesCompetitorsPhotos from './views/CompaniesCompetitorsPhotos.vue'
import RegistrationsBrand from './views/RegistrationsBrand'
// import RegistrationsSelect from './views/RegistrationsSelect'
// import RegistrationsStore from './views/RegistrationsStore'
// import RegistrationsStoreSites from './views/RegistrationsStoreSites'
import RegistrationsCompleted from './views/RegistrationsCompleted'
import RegistrationsBrandsLocations from './views/RegistrationsBrandsLocations'
import CompaniesVisitorStores from './views/CompaniesVisitorStores.vue'
import CompaniesVisitorStoreEdit from './views/CompaniesVisitorStoreEdit.vue'
import PaymentSetting from './views/PaymentSetting.vue'
import AccountSetting from './views/AccountSetting'
import UpgradePlan from './views/UpgradePlan'
import CompaniesManagement from './views/CompaniesManagement'
import CompaniesManagementBrands from './views/companies/management/Brands'
import CompaniesManagementCompetitorBrands from './views/companies/management/CompetitorBrands'
import CompaniesManagementKeywords from './views/companies/management/Keywords'
import CompaniesManagementAreas from './views/companies/management/Areas'
import CompaniesManagementFranchisees from './views/companies/management/Franchisees'
import CompaniesManagementOriginalTagGroups from './views/companies/management/OriginalTagGroups'
import CompaniesManagementOriginalTagGroupsTitleForm from './views/companies/management/originalTagGroups/TitleForm'
import CompaniesBrandForm from './views/CompaniesBrandForm'
import CompaniesCompetitorBrandForm from './views/CompaniesCompetitorBrandForm'
import CompaniesInvitationForm from './views/CompaniesInvitationForm'
import CompaniesFranchiseeForm from './views/CompaniesFranchiseeForm'
import CompaniesReplyTemplateForm from './views/CompaniesReplyTemplateForm'
import CompaniesGMBLinkageBrand from './views/CompaniesGMBLinkageBrand'
import CompaniesGMBLinkageLocations from './views/CompaniesGMBLinkageLocations'
import CompaniesGoogleOauth from './views/CompaniesGoogleOauth'
import CompaniesMemberRoleEdit from './views/CompaniesMemberRoleEdit'
import CompaniesAnalysisInsight from './views/companies/analysis/Insight'
import CompaniesAnalysisReviews from './views/companies/analysis/Reviews'
import CompaniesAnalysisVisitors from './views/companies/analysis/Visitors'
import CompaniesAnalysisKeywords from './views/companies/analysis/Keywords'
import CompaniesAnalysisSurveys from './views/companies/analysis/Surveys'
import CompaniesAnalysisSurveysDetail from './views/companies/analysis/surveys/Detail'
import CompaniesAnalysisRanking from './views/companies/analysis/Ranking'
import CompaniesAnalysisQscas from './views/companies/analysis/Qscas'
import CompaniesAnalysisQscasDetail from './views/companies/analysis/qscas/Detail'
import CompaniesAnalysisSearchQueries from './views/companies/analysis/SearchQueries.vue'
import CompaniesAnalysisScatter from './views/companies/analysis/Scatter'
import CompaniesTestimonialIndex from './views/companies/testimonials/Index'
import CompaniesTestimonialFiles from './views/companies/testimonials/Files'
import CompaniesAreasForm from './views/CompaniesAreasForm'
import CompaniesAnalysisSettingsKeywordForm from './views/companies/analysis/settings/KeywordForm'
import CompaniesAnalysisSettingsIgnoreForm from './views/companies/analysis/settings/IgnoreForm'
import CompaniesMailNotificationSetting from './views/CompaniesMailNotificationSetting'
import CompaniesExportResults from './views/CompaniesExportResults'
import { i18n } from './plugins/i18n'
import CompaniesGMBLocationSyncLogs from './views/CompaniesGMBLocationSyncLogs'
import CompaniesRpaErrorLogs from './views/CompaniesRpaErrorLogs'
import CompaniesChangePlan from './views/CompaniesChangePlan'
import CompaniesInitialSettingGuide from './views/companies/InitialSettingGuide'
import CompaniesManagementMembers from './views/companies/ManagementMembers'
import CompaniesManagementOriginalTagGroupsTagForm from './views/companies/management/originalTagGroups/TagForm'
import CompaniesFoodMenusIndex from './views/companies/foodMenus/Index'
import CompaniesFoodMenusForm from './views/companies/foodMenus/Form'
import CompaniesFoodMenusUploadedFiles from './views/companies/foodMenus/UploadedFiles'
import CompaniesMediaLibrary from './views/companies/MediaLibrary'
import CompaniesMediaLibraries from './views/companies/MediaLibraries'
import CompaniesMediaLibraryUpload from './views/companies/MediaLibraryUpload.vue'
import CompaniesMediaLibrariesBulkSet from './views/companies/mediaLibraries/BulkSet'
import CompaniesProductCategoryForm from './views/CompaniesProductCategoryForm'
import CompaniesManagementProductCategories from './views/companies/management/ProductCategories'
import CompaniesManagementParameters from './views/companies/management/Parameters'
import CompaniesManagementSearchPatterns from './views/companies/management/SearchPatterns'
import CompaniesManagementReplyTemplates from './views/companies/management/ReplyTemplates'
import CompaniesProductForm from './views/companies/products/Form'
import CompaniesProducts from './views/companies/products/Index'
import CompaniesProductsBulkSet from './views/companies/products/BulkSet'
import CompaniesProduct from './views/companies/products/Detail'
import CompaniesLocationStoreOpenInfoEdit from './views/CompaniesLocationStoreOpenInfoEdit'
import SurveyTemplateForm from './views/companies/SurveyTemplateForm'
import CompaniesCustomSurveyAnswers from './views/companies/customSurveys/Answers'
import CompaniesCustomSurveyAnswerFiles from './views/companies/customSurveys/AnswerFiles'
import CompaniesLocationStoreShufooEdit from './views/CompaniesLocationStoreShufooEdit'
import CompaniesLocationStoreMapionBizEdit from './views/CompaniesLocationStoreMapionBizEdit'
import CompaniesParameterForm from './views/CompaniesParameterForm'
import CompaniesPostsApprovalFlowForm from './views/CompaniesPostsApprovalFlowForm'
import CompaniesSnsApprovalFlowForm  from './views/companies/sns/ApprovalFlowForm'
import CompaniesReviewReplyApprovalFlowForm  from './views/companies/review/ReplyApprovalFlowForm.vue'
import CompaniesSearchPatternForm from './views/CompaniesSearchPatternForm'
import CompaniesServices from './views/companies/Services'
import CompaniesServicesForm from './views/companies/services/Form'
import CompaniesMapionBizSearchGroups from './views/companies/mapionBiz/SearchGroups'
import CompaniesMapionBizSearchGroupsForm from './views/companies/mapionBiz/searchGroups/Form'
import CompaniesMapionBizSearchGroupsStoresForm from './views/companies/mapionBiz/searchGroups/StoresForm'
import CompaniesLocationStoreMapionBizSearchGroupsEdit from './views/CompaniesLocationStoreMapionBizSearchGroupsEdit'
import CompaniesLocationStoreTabelogEdit from './views/CompaniesLocationStoreTabelogEdit'
import CompaniesMapionBizBannerTemplates from './views/companies/mapionBiz/Banner/Templates'
import CompaniesMapionBannerTemplateForm from './views/companies/mapionBiz/Banner/Template/Form'
import CompaniesSnsCategoryForm from './views/CompaniesSnsCategoryForm'
import CompaniesManagementSnsCategories from './views/companies/management/SnsCategories'
import CompaniesSearchKeywordImpressionLabels from './views/companies/management/SearchKeywordImpressionLabels'
import CompaniesSearchKeywordImpressionLabelForm from './views/companies/management/SearchKeywordImpressionLabelForm'
import CompaniesSnsOauth from './views/companies/sns/Oauth'
import CompaniesSnsInstagramHashtagList from './views/companies/sns/instagramHashtag/List'
import CompaniesSnsInstagramHashtagForm from './views/companies/sns/instagramHashtag/Form'
import CompaniesBenefitsIndex from './views/companies/benefits/Index'
import CompaniesBenefitsDetail from './views/companies/benefits/Detail'

// location
import {
  LocationStoreConnects,
  LocationStoreConnectGmb,
  LocationStoreConnectMapionbiz,
  LocationStoreConnectShufoo,
  LocationStoreConnectAccount,
} from './views/location'

const routes = [
  {
    path: '/s',
    component: Private,
    children: [
      {
        // 初回登録 ロケーション選択
        name: 'RegistrationsBrandsLocations',
        path: 'companies/:company_uuid/registrations/brands/:brand_id/locations',
        component: RegistrationsBrandsLocations
      },
      {
        // 初回登録 完了
        name: 'RegistrationsCompleted',
        path: 'companies/:company_uuid/registrations/completed',
        component: RegistrationsCompleted
      },
      // {
      //   // 初回登録 口コミサイト登録
      //   name: 'RegistrationsStoreSites',
      //   path: 'companies/:company_uuid/registrations/stores/:store_uuid/sites',
      //   component: RegistrationsStoreSites
      // },
      // // {
      // //   // 初回登録 店舗登録
      // //   name: 'RegistrationsStore',
      // //   path: 'companies/:company_uuid/registrations/brands/:brand_id/stores',
      // //   component: RegistrationsStore
      // // },
      // {
      //   // 初回登録 店舗登録方法選択
      //   name: 'RegistrationsSelect',
      //   path: 'companies/:company_uuid/registrations/select',
      //   component: RegistrationsSelect
      // },
      {
        // 初回登録 ブランド作成
        name: 'RegistrationsBrand',
        path: 'companies/:company_uuid/registrations/brand',
        component: RegistrationsBrand
      },
      {
        name: 'CompaniesDashboards',
        path: 'companies/:company_uuid/dashboards',
        component: CompaniesDashboards,
        meta: {
          title: i18n.t('pages.CompaniesDashboards.title'),
        }
      },
      {
        name: 'CompaniesInitialSettingGuide',
        path: 'companies/:company_uuid/initial_setting_guide',
        component: CompaniesInitialSettingGuide,
        meta: {
          title: i18n.t('pages.CompaniesInitialSettingGuide.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesInitialSettingGuide.title'),
            },
          ]
        }
      },
      {
        name: 'CompaniesReviews',
        path: 'companies/:company_uuid/reviews',
        component: CompaniesReviews,
        meta: {
          title: i18n.t('pages.CompaniesReviews.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesReviews.title'),
            },
          ],
        }
      },
      {
        name: 'CompaniesPhotos',
        path: 'companies/:company_uuid/photos',
        component: CompaniesPhotos,
        meta: {
          title: i18n.t('pages.CompaniesPhotos.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesPhotos.title'),
            },
          ],
        },
      },
      // お知らせ一覧
      {
        name: 'CompaniesNotifications',
        path: 'companies/:company_uuid/notifications',
        component: CompaniesNotifications,
        meta: {
          title: i18n.t('pages.CompaniesNotifications.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesNotifications.title'),
            },
          ],
        }
      },
      // お知らせ詳細
      {
        name: 'CompaniesNotification',
        path: 'companies/:company_uuid/notifications/:id',
        component: CompaniesNotification,
        meta: {
          title: i18n.t('pages.CompaniesNotification.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesNotifications.title'),
              pathName: 'CompaniesNotifications',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesNotification.title'),
            }
          ],
        }
      },
      // ソリューション 一覧
      {
        name: 'CompaniesBenefitsIndex',
        path: 'companies/:company_uuid/benefits',
        component: CompaniesBenefitsIndex,
        meta: {
          title: i18n.t('pages.CompaniesBenefits.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesBenefits.title'),
            },
          ],
        }
      },
      // ソリューション 詳細
      {
        name: 'CompaniesBenefitsDetail',
        path: 'companies/:company_uuid/benefits/:benefit_id',
        component: CompaniesBenefitsDetail,
        meta: {
          title: i18n.t('pages.CompaniesBenefits.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesBenefits.title'),
              pathName: 'CompaniesBenefitsIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesBenefitsDetail.title'),
            },
          ],
        }
      },
      // 店舗管理 一覧
      {
        name: 'CompaniesLocationStores',
        path: 'companies/:company_uuid/location/stores',
        component: CompaniesLocationStores,
        meta: {
          title: i18n.t('pages.CompaniesLocationStores.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
            },
          ],
        }
      },
      // 店舗管理 一括編集
      {
        name: 'CompaniesLocationStoresBulkEdit',
        path: 'companies/:company_uuid/location/stores/bulk_edit',
        component: CompaniesLocationStoresBulkEdit,
        meta: {
          title: i18n.t('pages.CompaniesLocationStoresBulkEdit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
            },
            {
              name: i18n.t('pages.CompaniesLocationStoresBulkEdit.title'),
            },
          ],
        }
      },
      // 店舗管理 一括取り込み
      {
        name: 'CompaniesLocationStoresBulkUpdateWithGmb',
        path: 'companies/:company_uuid/location/stores/bulk_update_with_gmb',
        component: CompaniesLocationStoresBulkUpdateWithGmb,
        meta: {
          title: i18n.t('pages.CompaniesLocationStoresBulkUpdateWithGmb.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
            },
            {
              name: i18n.t('pages.CompaniesLocationStoresBulkUpdateWithGmb.title'),
            },
          ],
        }
      },
      // 店舗管理 GBP情報の一括書き換え
      {
        name: 'CompaniesLocationStoresBulkUpdateInGmb',
        path: 'companies/:company_uuid/location/stores/bulk_update_in_gmb',
        component: CompaniesLocationStoresBulkUpdateInGmb,
        meta: {
          title: i18n.t('pages.CompaniesLocationStoresBulkUpdateInGmb.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
            },
            {
              name: i18n.t('pages.CompaniesLocationStoresBulkUpdateInGmb.title'),
            },
          ],
        }
      },
      // 店舗管理 オプション一括編集
      {
        name: 'CompaniesLocationStoresBulkEditStoreOptions',
        path: 'companies/:company_uuid/location/stores/bulk_edit_options',
        component: CompaniesLocationStoresBulkEditStoreOptions,
        meta: {
          title: i18n.t('pages.CompaniesLocationStoresBulkEditStoreOptions.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
            },
            {
              name: i18n.t('pages.CompaniesLocationStoresBulkEditStoreOptions.title'),
            },
          ],
        }
      },
      // 店舗管理 新規
      {
        name: 'CompaniesLocationStoreNew',
        path: 'companies/:company_uuid/location/stores/new',
        component: CompaniesLocationStoreNew,
        meta: {
          title: i18n.t('pages.CompaniesLocationStoreNew.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreNew.title'),
            },
          ],
        }
      },
      // 店舗管理 詳細
      {
        name: 'CompaniesLocationStore',
        path: 'companies/:company_uuid/location/stores/:store_uuid',
        component: CompaniesLocationStore,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理 属性設定
      {
        name: 'CompaniesLocationStoreAttributesEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/attributes/edit',
        component: CompaniesLocationStoreAttributesEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreAttributesEdit.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理 属性URL設定
      {
        name: 'CompaniesLocationStoreUrlEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/url_attributes/:attribute_id/edit',
        component: CompaniesLocationStoreAttributesUrlEdit,
      },
      // 店舗管理 属性複数URL設定
      {
        name: 'CompaniesLocationStoreMultipleUrlEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/multiple_url_attributes/:attribute_id/edit',
        component: CompaniesLocationStoreAttributesMultipleUrlEdit,
      },
      // 店舗管理 料理の注文リンク設定
      {
        name: 'CompaniesLocationStorePlaceActionLinksFoodorderingsEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/place_action_links/food_orderings/edit',
        component: CompaniesLocationStorePlaceActionLinksFoodorderingsEdit,
      },
      // 店舗管理:基本情報 編集
      {
        name: 'CompaniesLocationStoreEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/edit',
        component: CompaniesLocationStoreEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreEdit.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理:決済手段 編集
      {
        name: 'CompaniesLocationStorePaymentMethodsEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/payment_methods/edit',
        component: CompaniesLocationStorePaymentMethodsEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStorePaymentMethodsEdit.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理:営業時間 編集
      {
        name: 'CompaniesLocationStoreRegularHoursEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/regular_hours/edit',
        component: CompaniesLocationStoreRegularHoursEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreRegularHoursEdit.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理:営業ステータス 編集
      {
        name: 'CompaniesLocationStoreOpenInfoEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/open_info/edit',
        component: CompaniesLocationStoreOpenInfoEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreOpenInfoEdit.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理:カテゴリー 編集
      {
        name: 'CompaniesLocationStoreCategoriesEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/categories/edit',
        component: CompaniesLocationStoreCategoriesEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreCategoriesEdit.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理: 店舗詳細: 連携タブ（連携情報一覧）
      {
        name: 'LocationStoreConnects',
        path: 'companies/:company_uuid/location/stores/:store_uuid/connects',
        component: LocationStoreConnects,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
            },
          ],
        },
      },
      // 店舗管理: 店舗詳細: Google マップ連携
      {
        name: 'LocationStoreConnectGmb',
        path: 'companies/:company_uuid/location/stores/:store_uuid/connects/gmb',
        component: LocationStoreConnectGmb,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.LocationStoreConnectGmb.basicTitle'),
            },
          ],
        },
      },
      // 店舗管理: 店舗詳細: Shufoo連携
      {
        name: 'LocationStoreConnectShufoo',
        path: 'companies/:company_uuid/location/stores/:store_uuid/connects/shufoo',
        component: LocationStoreConnectShufoo,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.LocationStoreConnectShufoo.basicTitle'),
            },
          ],
        },
      },
      // 店舗管理: 店舗詳細: MapionBiz連携
      {
        name: 'LocationStoreConnectMapionbiz',
        path: 'companies/:company_uuid/location/stores/:store_uuid/connects/mapion_biz',
        component: LocationStoreConnectMapionbiz,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.LocationStoreConnectMapionbiz.basicTitle'),
            },
          ],
        },
      },
      // 店舗管理: その他サービス連携情報連携
      {
        name: 'LocationStoreConnectAccount',
        path: 'companies/:company_uuid/location/stores/:store_uuid/connects/:site_name',
        component: LocationStoreConnectAccount,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.LocationStoreConnectAccount.basicTitle'),
            },
          ],
        },
      },
      // 店舗管理:Shufoo 編集
      {
        name: 'CompaniesLocationStoreShufooEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/shufoo/edit',
        component: CompaniesLocationStoreShufooEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreShufooEdit.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理:MapionBiz 編集
      {
        name: 'CompaniesLocationStoreMapionBizEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/mapion_biz/edit',
        component: CompaniesLocationStoreMapionBizEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreMapionBizEdit.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理:MapionBiz 絞り込み条件編集
      {
        name: 'CompaniesLocationStoreMapionBizSearchGroupsEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/mapion_biz/search_groups/edit',
        component: CompaniesLocationStoreMapionBizSearchGroupsEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreMapionBizSearchGroupsEdit.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理:食べログ 編集
      {
        name: 'CompaniesLocationStoreTabelogEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/tabelog/edit',
        component: CompaniesLocationStoreTabelogEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreTabelogEdit.basicTitle'),
            },
          ],
        }
      },
      // 店舗管理:競合店舗 新規
      {
        name: 'CompaniesLocationStoreCompetitorNew',
        path: 'companies/:company_uuid/location/stores/:store_uuid/competitor/new',
        component: CompaniesLocationStoreCompetitor,
        meta: {
          title: i18n.t('pages.CompaniesLocationStoreCompetitorNew.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreCompetitorNew.title'),
            },
          ],
        }
      },
      // 店舗管理:競合店舗 編集
      {
        name: 'CompaniesLocationStoreCompetitorEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/competitor/:competitor_id/edit',
        component: CompaniesLocationStoreCompetitor,
        meta: {
          title: i18n.t('pages.CompaniesLocationStoreCompetitorEdit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreCompetitorEdit.title'),
            },
          ],
        }
      },
      // 店舗管理:Googleマップ情報 編集
      {
        name: 'CompaniesLocationStoreGmbInfosEdit',
        path: 'companies/:company_uuid/location/stores/:store_uuid/gmb_infos/edit',
        component: CompaniesLocationStoreGmbInfosEdit,
        meta: {
          title: i18n.t('pages.CompaniesLocationStoreGmbInfosEdit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreGmbInfosEdit.title'),
            },
          ],
        }
      },
      // 各店舗：写真詳細
      {
        name: 'CompaniesLocationStoreMediaLibrary',
        path: 'companies/:company_uuid/location/stores/:store_uuid/media_libraries/:id',
        component: CompaniesLocationStoreMediaLibrary,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreMediaLibrary.basicTitle'),
            },
          ],
        },
      },
      // 各店舗：写真アップロード
      {
        name: 'CompaniesLocationStoreMediaLibraryUpload',
        path: 'companies/:company_uuid/location/stores/:store_uuid/media_library/upload',
        component: CompaniesLocationStoreMediaLibraryUpload,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreMediaLibraryUpload.basicTitle'),
            },
          ],
        },
      },
      // 各店舗：写真一覧
      {
        name: 'CompaniesLocationStoreMediaLibraries',
        path: 'companies/:company_uuid/location/stores/:store_uuid/media_libraries',
        component: CompaniesLocationStoreMediaLibraries,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreMediaLibraries.title'),
            },
          ],
        },
      },
      // 各店舗：商品詳細
      {
        name: 'CompaniesLocationStoreProduct',
        path: 'companies/:company_uuid/location/stores/:store_uuid/products/:id',
        component: CompaniesLocationStoreProduct,
        meta: {
          title: i18n.t('pages.CompaniesLocationStoreProductDetail.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStores.title'),
              pathName: 'CompaniesLocationStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStore.basicTitle'),
              pathName: 'CompaniesLocationStore',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesLocationStoreProductDetail.title'),
            },
          ],
        },
      },
      // Google My Business 投稿一覧
      {
        name: 'CompaniesStorePostsIndex',
        path: 'companies/:company_uuid/posts',
        component: CompaniesStorePostsIndex,
        meta: {
          title: i18n.t('pages.CompaniesStorePost.index.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStorePost.index.title'),
            },
          ],
        }
      },
      // Google My Business 新規投稿
      {
        name: 'CompaniesStorePostsNew',
        path: 'companies/:company_uuid/posts/new',
        component: CompaniesStorePostsForm,
        meta: {
          title: i18n.t('pages.CompaniesStorePost.new.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStorePost.index.title'),
              pathName: 'CompaniesStorePostsIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStorePost.new.title'),
            },
          ],
        }
      },
      // Google My Business 投稿編集
      {
        name: 'CompaniesStorePostsEdit',
        path: 'companies/:company_uuid/posts/:post_id/edit',
        component: CompaniesStorePostsForm,
        meta: {
          title: i18n.t('pages.CompaniesStorePost.edit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStorePost.index.title'),
              pathName: 'CompaniesStorePostsIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStorePost.edit.title'),
            },
          ],
        }
      },
      // Google My Business 投稿下書き編集
      {
        name: 'CompaniesStoreDraftedPostsEdit',
        path: 'companies/:company_uuid/drafted_posts/:drafted_post_id/edit',
        component: CompaniesStorePostsForm,
        meta: {
          title: i18n.t('pages.CompaniesStorePost.edit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStorePost.index.title'),
              pathName: 'CompaniesStorePostsIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStorePost.edit.title'),
            },
          ],
        }
      },
      // Google My Business 投稿申請中の投稿編集(差し戻しステータス)
      {
        name: 'CompaniesStoreRequestingPostsEdit',
        path: 'companies/:company_uuid/requesting_posts/:requesting_post_id/edit',
        component: CompaniesStorePostsForm,
        meta: {
          title: i18n.t('pages.CompaniesStorePost.edit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStorePost.index.title'),
              pathName: 'CompaniesStorePostsIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStorePost.edit.title'),
            },
          ],
        }
      },
      // SNS 投稿一覧
      {
        name: 'CompaniesStoreSnsPostsIndex',
        path: 'companies/:company_uuid/sns/posts',
        component: CompaniesStoreSnsPostsIndex,
        meta: {
          title: i18n.t('pages.CompaniesStoreSnsPost.index.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStoreSnsPost.index.title'),
            },
          ],
        }
      },
      // SNS 新規投稿
      {
        name: 'CompaniesStoreSnsPostsNew',
        path: 'companies/:company_uuid/sns/posts/new',
        component: CompaniesStoreSnsPostsForm,
        meta: {
          title: i18n.t('pages.CompaniesStoreSnsPost.new.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStoreSnsPost.index.title'),
              pathName: 'CompaniesStoreSnsPostsIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStoreSnsPost.new.title'),
            },
          ],
        }
      },
      // SNS 投稿編集
      {
        name: 'CompaniesStoreSnsPostsEdit',
        path: 'companies/:company_uuid/sns/posts/:post_id/edit',
        component: CompaniesStoreSnsPostsForm,
        meta: {
          title: i18n.t('pages.CompaniesStoreSnsPost.edit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStoreSnsPost.index.title'),
              pathName: 'CompaniesStoreSnsPostsIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStoreSnsPost.edit.title'),
            },
          ],
        }
      },
      // SNS 投稿下書き編集
      {
        name: 'CompaniesStoreSnsDraftedPostsEdit',
        path: 'companies/:company_uuid/sns/drafted_posts/:drafted_post_id/edit',
        component: CompaniesStoreSnsPostsForm,
        meta: {
          title: i18n.t('pages.CompaniesStoreSnsPost.edit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStoreSnsPost.index.title'),
              pathName: 'CompaniesStoreSnsPostsIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStoreSnsPost.edit.title'),
            },
          ],
        }
      },
      // SNS 投稿申請中の投稿編集(差し戻しステータス)
      {
        name: 'CompaniesStoreSnsRequestingPostsEdit',
        path: 'companies/:company_uuid/sns/requesting_posts/:requesting_post_id/edit',
        component: CompaniesStoreSnsPostsForm,
        meta: {
          title: i18n.t('pages.CompaniesStoreSnsPost.edit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStoreSnsPost.index.title'),
              pathName: 'CompaniesStoreSnsPostsIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesStoreSnsPost.edit.title'),
            },
          ],
        }
      },
      // アンケート
      {
        name: 'CompaniesSurveys',
        path: 'companies/:company_uuid/surveys',
        component: CompaniesSurveys,
        meta: {
          title: i18n.t('pages.CompaniesSurveys.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesSurveys.title'),
            },
          ],
        }
      },
      // アンケート 新規作成
      {
        name: 'CompaniesSurveysNew',
        path: 'companies/:company_uuid/survey_templates/new',
        component: SurveyTemplateForm,
        meta: {
          title: i18n.t('pages.CompaniesSurveysNew.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesSurveys.title'),
              pathName: 'CompaniesSurveys',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesSurveysNew.title'),
            },
          ],
        }
      },
      // アンケート 編集
      {
        name: 'CompaniesSurveysEdit',
        path: 'companies/:company_uuid/survey_templates/:survey_id',
        component: SurveyTemplateForm,
        meta: {
          title: i18n.t('pages.CompaniesSurveysEdit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesSurveys.title'),
              pathName: 'CompaniesSurveys',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesSurveysEdit.title'),
            },
          ],
        }
      },
      // 競合 口コミ一覧
      {
        name: 'CompaniesCompetitorsReviews',
        path: 'companies/:company_uuid/competitors/reviews',
        component: CompaniesCompetitorsReviews,
        meta: {
          title: i18n.t('pages.CompaniesCompetitorsReviews.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesCompetitorsReviews.title'),
            },
          ],
        }
      },
      // 競合 投稿写真一覧
      {
        name: 'CompaniesCompetitorsPhotos',
        path: 'companies/:company_uuid/competitors/photos',
        component: CompaniesCompetitorsPhotos,
        meta: {
          title: i18n.t('pages.CompaniesCompetitorsPhotos.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesCompetitorsPhotos.title'),
            },
          ],
        }
      },
      // 店舗ページ一覧
      {
        name: 'CompaniesVisitorStores',
        path: 'companies/:company_uuid/visitor/stores',
        component: CompaniesVisitorStores,
        meta: {
          title: i18n.t('pages.CompaniesVisitorStores.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesVisitorStores.title'),
            },
          ],
        }
      },
      // 店舗ページ編集
      {
        name: 'CompaniesVisitorStoreEdit',
        path: 'companies/:company_uuid/visitor/stores/:store_uuid/edit',
        component: CompaniesVisitorStoreEdit,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesVisitorStores.title'),
              pathName: 'CompaniesVisitorStores',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesVisitorStoreEdit.basicTitle'),
            }
          ],
        },
      },
      // プランお支払い情報
      {
        name: 'PaymentSetting',
        path: 'companies/:company_uuid/payment_settings',
        component: PaymentSetting,
        meta: {
          title: i18n.t('pages.companies.paymentSetting.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.paymentSetting.title'),
            },
          ],
        }
      },
      // アカウント設定
      {
        name: 'AccountSetting',
        path: 'companies/:company_uuid/account_setting',
        component: AccountSetting,
        meta: {
          title: i18n.t('pages.companies.accountSetting.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.accountSetting.title'),
            },
          ],
        }
      },
      // プラン更新
      {
        name: 'UpgradePlan',
        path: 'companies/:company_uuid/upgrade_plan/new',
        component: UpgradePlan,
        meta: {
          title: i18n.t('pages.companies.upgradePlan.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.paymentSetting.title'),
              pathName: 'PaymentSetting',
              query: {},
            },
            {
              name: i18n.t('pages.companies.upgradePlan.title'),
            },
          ],
        }
      },
      // 管理
      {
        name: 'CompaniesManagement',
        path: 'companies/:company_uuid/management',
        component: CompaniesManagement,
        meta: {
          title: i18n.t('pages.companies.management.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
            },
          ],
        }
      },
      // メンバー管理
      {
        name: 'CompaniesManagementMembers',
        path: 'companies/:company_uuid/management_members',
        component: CompaniesManagementMembers,
        meta: {
          title: i18n.t('pages.companies.managementMembers.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.managementMembers.title'),
            },
          ],
        }
      },
      // ブランド管理
      {
        name: 'CompaniesManagementBrands',
        path: 'companies/:company_uuid/management/brands',
        component: CompaniesManagementBrands,
        meta: {
          title: i18n.t('pages.companies.management.brands.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.brands.title'),
            },
          ],
        }
      },
      // 競合ブランド管理
      {
        name: 'CompaniesManagementCompetitorBrands',
        path: 'companies/:company_uuid/management/competitor_brands',
        component: CompaniesManagementCompetitorBrands,
        meta: {
          title: i18n.t('pages.companies.management.competitorBrands.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.competitorBrands.title'),
            },
          ],
        }
      },
      // キーワード管理
      {
        name: 'CompaniesManagementKeywords',
        path: 'companies/:company_uuid/management/keywords',
        component: CompaniesManagementKeywords,
        meta: {
          title: i18n.t('pages.companies.management.keywords.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.keywords.title'),
            },
          ],
        }
      },
      // 立地管理
      {
        name: 'CompaniesManagementAreas',
        path: 'companies/:company_uuid/management/areas',
        component: CompaniesManagementAreas,
        meta: {
          title: i18n.t('pages.companies.management.areas.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.areas.title'),
            },
          ],
        }
      },
      // フランチャイジー管理
      {
        name: 'CompaniesManagementFranchisees',
        path: 'companies/:company_uuid/management/franchisees',
        component: CompaniesManagementFranchisees,
        meta: {
          title: i18n.t('pages.companies.management.franchisees.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.franchisees.title'),
            },
          ],
        }
      },
      // 商品カテゴリ管理
      {
        name: 'CompaniesManagementProductCategories',
        path: 'companies/:company_uuid/management/product_categories',
        component: CompaniesManagementProductCategories,
        meta: {
          title: i18n.t('pages.companies.management.productCategories.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.productCategories.title'),
            },
          ],
        }
      },
      // 店舗別パラメータ設定
      {
        name: 'CompaniesManagementParameters',
        path: 'companies/:company_uuid/management/parameters',
        component: CompaniesManagementParameters,
        meta: {
          title: i18n.t('pages.companies.management.parameters.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.parameters.title'),
            },
          ],
        }
      },
      // 絞り込み条件の新着メール配信
      {
        name: 'CompaniesManagementSearchPatterns',
        path: 'companies/:company_uuid/management/search_patterns',
        component: CompaniesManagementSearchPatterns,
        meta: {
          title: i18n.t('pages.companies.management.searchPatterns.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.searchPatterns.title'),
            },
          ],
        }
      },
      // SNSカテゴリ管理
      {
        name: 'CompaniesManagementSnsCategories',
        path: 'companies/:company_uuid/management/sns/categories',
        component: CompaniesManagementSnsCategories,
        meta: {
          title: i18n.t('pages.companies.management.snsCategories.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.management.snsCategories.title'),
            },
          ],
        }
      },
      // 口コミ返信テンプレート設定
      {
        name: 'CompaniesManagementReplyTemplates',
        path: 'companies/:company_uuid/management/reply_templates',
        component: CompaniesManagementReplyTemplates,
        meta: {
          title: i18n.t('pages.companies.management.replyTemplates.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.replyTemplates.title'),
            },
          ],
        }
      },
      // 口コミ返信テンプレート設定 - 編集
      {
        name: 'CompaniesManagementReplyTemplatesEdit',
        path: 'companies/:company_uuid/management/reply_templates/:reply_template_id/edit',
        component: CompaniesReplyTemplateForm,
        meta: {
          title: i18n.t('pages.companies.management.replyTemplates.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.replyTemplates.title'),
            },
          ],
        }
      },
      // 口コミ返信テンプレート設定 - 新規
      {
        name: 'CompaniesManagementReplyTemplatesNew',
        path: 'companies/:company_uuid/management/reply_templates/new',
        component: CompaniesReplyTemplateForm,
        meta: {
          title: i18n.t('pages.companies.management.replyTemplates.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.replyTemplates.title'),
            },
          ],
        }
      },
      // タググループ編集
      {
        name: 'CompaniesManagementOriginalTagGroupsEdit',
        path: 'companies/:company_uuid/management/original/tag_groups/:tag_group_kind/edit',
        component: CompaniesManagementOriginalTagGroups,
        meta: {
          title: i18n.t('pages.companies.management.originalTagGroups.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.originalTagGroups.title'),
            },
          ],
        }
      },
      // タググループ作成
      {
        name: 'CompaniesManagementOriginalTagGroupsNew',
        path: 'companies/:company_uuid/management/original/tag_groups/new',
        component: CompaniesManagementOriginalTagGroups,
        meta: {
          title: i18n.t('pages.companies.management.originalTagGroups.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.originalTagGroups.title'),
            },
          ],
        }
      },
      // タググループタイトル作成
      {
        name: 'CompaniesManagementOriginalTagGroupsTitleNew',
        path: 'companies/:company_uuid/management/original/tag_groups/title/new',
        component: CompaniesManagementOriginalTagGroupsTitleForm,
        meta: {
          title: i18n.t('pages.companies.management.originalTagGroups.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.originalTagGroups.title'),
            },
          ],
        }
      },
      // タググループタイトル編集
      {
        name: 'CompaniesManagementOriginalTagGroupsTitleEdit',
        path: 'companies/:company_uuid/management/original/tag_groups/:tag_group_kind/title/edit',
        component: CompaniesManagementOriginalTagGroupsTitleForm,
        meta: {
          title: i18n.t('pages.companies.management.originalTagGroups.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.originalTagGroups.title'),
            },
          ],
        }
      },
      // タググループの要素新規作成
      {
        name: 'CompaniesManagementOriginalTagGroupsTagsNew',
        path: 'companies/:company_uuid/management/original/tag_groups/:tag_group_kind/tags',
        component: CompaniesManagementOriginalTagGroupsTagForm,
        meta: {
          title: i18n.t('pages.companies.management.originalTagGroups.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.originalTagGroups.title'),
            },
          ],
        }
      },
      // タググループの要素編集
      {
        name: 'CompaniesManagementOriginalTagGroupsTagsEdit',
        path: 'companies/:company_uuid/management/original/tag_groups/:tag_group_kind/tags/:tag_id',
        component: CompaniesManagementOriginalTagGroupsTagForm,
        meta: {
          title: i18n.t('pages.companies.management.originalTagGroups.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.originalTagGroups.title'),
            },
          ],
        }
      },
      // ブランド管理 - 新規作成
      {
        name: 'CompaniesBrandNew',
        path: 'companies/:company_uuid/management/brands/new',
        component: CompaniesBrandForm,
        meta: {
          title: i18n.t('pages.companies.brandForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.brandForm.title'),
            },
          ],
        }
      },
      // ブランド管理 - 編集
      {
        name: 'CompaniesBrandEdit',
        path: 'companies/:company_uuid/management/brands/:brand_id/edit',
        component: CompaniesBrandForm,
        meta: {
          title: i18n.t('pages.companies.brandForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.brandForm.title'),
            },
          ],
        }
      },
      // 競合ブランド管理 - 新規作成
      {
        name: 'CompaniesCompetitorBrandNew',
        path: 'companies/:company_uuid/management/competitor_brands/new',
        component: CompaniesCompetitorBrandForm,
        meta: {
          title: i18n.t('pages.companies.competitorBrandForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.competitorBrandForm.title'),
            },
          ],
        }
      },
      // 競合ブランド管理 - 編集
      {
        name: 'CompaniesCompetitorBrandEdit',
        path: 'companies/:company_uuid/management/competitor_brands/:competitor_brand_id/edit',
        component: CompaniesCompetitorBrandForm,
        meta: {
          title: i18n.t('pages.companies.competitorBrandForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.competitorBrandForm.title'),
            },
          ],
        }
      },
      // メンバー管理 - 新規招待
      {
        name: 'CompaniesInvitationForm',
        path: 'companies/:company_uuid/management/invitations/new',
        component: CompaniesInvitationForm,
        meta: {
          title: i18n.t('pages.companies.invitationForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.managementMembers.title'),
              pathName: 'CompaniesManagementMembers',
            },
            {
              name: i18n.t('pages.companies.invitationForm.title'),
            },
          ],
        }
      },
      // メンバー管理 - 編集
      {
        name: 'CompaniesMemberRoleEdit',
        path: 'companies/:company_uuid/management/user_companies/:user_company_id/edit',
        component: CompaniesMemberRoleEdit,
        meta: {
          title: i18n.t('pages.companies.memberRoleEdit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.managementMembers.title'),
              pathName: 'CompaniesManagementMembers',
            },
            {
              name: i18n.t('pages.companies.memberRoleEdit.title'),
            },
          ],
        }
      },
      // フランチャイジー管理 - 新規作成
      {
        name: 'CompaniesFranchiseeNew',
        path: 'companies/:company_uuid/management/franchisees/new',
        component: CompaniesFranchiseeForm,
        meta: {
          title: i18n.t('pages.companies.franchiseeForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: { currentTab: 'Franchisee' },
            },
            {
              name: i18n.t('pages.companies.franchiseeForm.title'),
            },
          ],
        }
      },
      // フランチャイジー管理 - 編集
      {
        name: 'CompaniesFranchiseeEdit',
        path: 'companies/:company_uuid/management/franchisees/:franchisee_id/edit',
        component: CompaniesFranchiseeForm,
        meta: {
          title: i18n.t('pages.companies.franchiseeForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: { currentTab: 'Franchisee' },
            },
            {
              name: i18n.t('pages.companies.franchiseeForm.title'),
            },
          ],
        }
      },
      // 立地管理 - 新規作成
      {
        name: 'CompaniesAreasNew',
        path: 'companies/:company_uuid/management/areas/new',
        component: CompaniesAreasForm,
        meta: {
          title: i18n.t('pages.companies.areaForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: { currentTab: 'Area' },
            },
            {
              name: i18n.t('pages.companies.areaForm.title'),
            },
          ],
        }
      },
      // 立地管理 - 編集
      {
        name: 'CompaniesAreasEdit',
        path: 'companies/:company_uuid/management/areas/:area_id/edit',
        component: CompaniesAreasForm,
        meta: {
          title: i18n.t('pages.companies.areaForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: { currentTab: 'Area' },
            },
            {
              name: i18n.t('pages.companies.areaForm.title'),
            },
          ],
        }
      },
      // 商品カテゴリ管理 - 新規作成
      {
        name: 'CompaniesProductCategoryNew',
        path: 'companies/:company_uuid/management/product_categories/new',
        component: CompaniesProductCategoryForm,
        meta: {
          title: i18n.t('pages.companies.productCategoryForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.productCategoryForm.title'),
            },
          ],
        }
      },
      // 商品カテゴリ管理 - 編集
      {
        name: 'CompaniesProductCategoryEdit',
        path: 'companies/:company_uuid/management/product_categories/:product_category_id/edit',
        component: CompaniesProductCategoryForm,
        meta: {
          title: i18n.t('pages.companies.productCategoryForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.productCategoryForm.title'),
            },
          ],
        }
      },
      // 店舗別パラメータ管理 - 新規作成
      {
        name: 'CompaniesParameterNew',
        path: 'companies/:company_uuid/management/parameters/new',
        component: CompaniesParameterForm,
        meta: {
          title: i18n.t('pages.companies.parameterForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.parameterForm.title'),
            },
          ],
        }
      },
      // 店舗別パラメータ管理 - 編集
      {
        name: 'CompaniesParameterEdit',
        path: 'companies/:company_uuid/management/parameters/:parameter_id/edit',
        component: CompaniesParameterForm,
        meta: {
          title: i18n.t('pages.companies.parameterForm.editTitle'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.parameterForm.editTitle'),
            },
          ],
        }
      },
      // 絞り込み条件の新着メール配信 - 編集
      {
        name: 'CompaniesManagementSearchPatternsEdit',
        path: 'companies/:company_uuid/management/search_patterns/:search_pattern_id/edit',
        component: CompaniesSearchPatternForm,
      },
      // SNSカテゴリ管理 - 新規作成
      {
        name: 'CompaniesSnsCategoryNew',
        path: 'companies/:company_uuid/management/sns/categories/new',
        component: CompaniesSnsCategoryForm,
        meta: {
          title: i18n.t('pages.companies.snsCategoryForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.snsCategoryForm.title'),
            },
          ],
        }
      },
      // SNSカテゴリ管理 - 編集
      {
        name: 'CompaniesSnsCategoryEdit',
        path: 'companies/:company_uuid/management/sns/categories/:sns_category_id/edit',
        component: CompaniesSnsCategoryForm,
        meta: {
          title: i18n.t('pages.companies.snsCategoryForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.snsCategoryForm.title'),
            },
          ],
        }
      },
      // 指定ワード管理 - 新規作成
      {
        name: 'CompaniesReviewSettingKeywordNew',
        path: 'companies/:company_uuid/management/analysis/settings/keywords/new',
        component: CompaniesAnalysisSettingsKeywordForm,
        meta: {
          title: i18n.t('pages.companies.keywordForm.analysis.settings.keyword.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: { currentTab: 'Keyword' },
            },
            {
              name: i18n.t('pages.companies.keywordForm.analysis.settings.keyword.title'),
            },
          ],
        }
      },
      // 除外キーワード管理 - 新規作成
      {
        name: 'CompaniesReviewSettingIgnoreNew',
        path: 'companies/:company_uuid/management/analysis/settings/ignores/new',
        component: CompaniesAnalysisSettingsIgnoreForm,
        meta: {
          title: i18n.t('pages.companies.keywordForm.analysis.settings.ignore.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: { currentTab: 'Keyword' },
            },
            {
              name: i18n.t('pages.companies.keywordForm.analysis.settings.ignore.title'),
            },
          ],
        }
      },
      // 承認フロー管理 - 編集
      {
        name: 'CompaniesPostsApprovalFlowForm',
        path: 'companies/:company_uuid/management/posts/approval_flow',
        component: CompaniesPostsApprovalFlowForm,
        meta: {
          title: i18n.t('pages.companies.postApprovalFlowForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.postApprovalFlowForm.title'),
            },
          ],
        }
      },
      // SNS承認フロー管理 - 編集
      {
        name: 'CompaniesSnsApprovalFlowForm',
        path: 'companies/:company_uuid/management/sns/approval_flow',
        component: CompaniesSnsApprovalFlowForm,
        meta: {
          title: i18n.t('pages.companies.snsApprovalFlowForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.snsApprovalFlowForm.title'),
            },
          ],
        }
      },
      // 口コミ返信承認フロー管理 - 編集
      {
        name: 'CompaniesReviewReplyApprovalFlowForm',
        path: 'companies/:company_uuid/management/reviews/replies/approval_flow',
        component: CompaniesReviewReplyApprovalFlowForm,
        meta: {
          title: i18n.t('pages.companies.reviewReplyApprovalFlowForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.reviewReplyApprovalFlowForm.title'),
            },
          ],
        }
      },
      // Mapion Biz絞り込み条件
      {
        name: 'CompaniesMapionBizSearchGroups',
        path: 'companies/:company_uuid/management/mapion_biz/search_groups',
        component: CompaniesMapionBizSearchGroups,
        meta: {
          title: i18n.t('pages.companies.management.mapionBizSearchGroups.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.mapionBizSearchGroups.title'),
            },
          ],
        }
      },
      // Mapion Biz絞り込み条件 - 新規作成
      {
        name: 'CompaniesMapionBizSearchGroupsNew',
        path: 'companies/:company_uuid/management/mapion_biz/search_groups/new',
        component: CompaniesMapionBizSearchGroupsForm,
        meta: {
          title: i18n.t('pages.companies.mapionBizSearchGroupsForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.mapionBizSearchGroupsForm.title'),
            },
          ],
        }
      },
      // Mapion Biz絞り込み条件 - 編集
      {
        name: 'CompaniesMapionBizSearchGroupsEdit',
        path: 'companies/:company_uuid/management/mapion_biz/search_groups/:search_group_id/edit',
        component: CompaniesMapionBizSearchGroupsForm,
        meta: {
          title: i18n.t('pages.companies.mapionBizSearchGroupsForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.mapionBizSearchGroupsForm.title'),
            },
          ],
        }
      },
      // Mapion Biz絞り込み条件店舗 - 編集
      {
        name: 'CompaniesMapionBizSearchGroupsStoreEdit',
        path: 'companies/:company_uuid/management/mapion_biz/search_groups/:search_group_id/stores/edit',
        component: CompaniesMapionBizSearchGroupsStoresForm,
        meta: {
          title: i18n.t('pages.companies.mapionBizSearchGroupsForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.mapionBizSearchGroupsForm.title'),
            },
          ],
        }
      },
      // Mapion Bizフリー項目
      {
        name: 'CompaniesMapionBizBannerTemplates',
        path: 'companies/:company_uuid/management/mapion_biz/banner/templates',
        component: CompaniesMapionBizBannerTemplates,
        meta: {
          title: i18n.t('pages.companies.mapionBizBannerTemplates.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
              query: {},
            },
            {
              name: i18n.t('pages.companies.mapionBizBannerTemplates.title'),
            },
          ],
        }
      },
      // Mapion Bizフリー項目 - 新規作成
      {
        name: 'CompaniesMapionBannerTemplateNew',
        path: 'companies/:company_uuid/management/mapion_biz/banner/template/new',
        component: CompaniesMapionBannerTemplateForm,
        meta: {
          title: i18n.t('pages.companies.mapionBizBannerTemplateForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.mapionBizBannerTemplateForm.title'),
            },
          ],
        }
      },
      // Mapion Bizフリー項目 - 編集
      {
        name: 'CompaniesMapionBannerTemplateEdit',
        path: 'companies/:company_uuid/management/mapion_biz/banner/template/:template_id/edit',
        component: CompaniesMapionBannerTemplateForm,
        meta: {
          title: i18n.t('pages.companies.mapionBizBannerTemplateForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.mapionBizBannerTemplateForm.title'),
            },
          ],
        }
      },
      // 検索ワードラベル設定
      {
        name: 'CompaniesSearchKeywordImpressionLabels',
        path: 'companies/:company_uuid/management/search_keyword_impression_labels',
        component: CompaniesSearchKeywordImpressionLabels,
        meta: {
          title: i18n.t('pages.companies.searchKeywordImpressionLabels.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.searchKeywordImpressionLabels.title'),
            },
          ],
        },
      },
      // 検索ワードラベル編集
      {
        name: 'CompaniesSearchKeywordImpressionLabelForm',
        path: 'companies/:company_uuid/management/search_keyword_impression_labels/:label_id',
        component: CompaniesSearchKeywordImpressionLabelForm,
        meta: {
          title: i18n.t('pages.companies.searchKeywordImpressionLabelEdit.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.management.title'),
              pathName: 'CompaniesManagement',
            },
            {
              name: i18n.t('pages.companies.searchKeywordImpressionLabelEdit.title'),
            },
          ],
        },
      },
      // Googleアカウント連携
      {
        name: 'CompaniesGoogleOauth',
        path: 'companies/:company_uuid/google_oauth',
        component: CompaniesGoogleOauth,
        meta: {
          title: i18n.t('pages.companies.googleOauth.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.googleOauth.title'),
            }
          ],
        }
      },
      // SNSアカウント連携
      {
        name: 'CompaniesSnsOauth',
        path: 'companies/:company_uuid/sns_oauth',
        component: CompaniesSnsOauth,
        meta: {
          title: i18n.t('pages.companies.snsOauth.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.snsOauth.title'),
            }
          ],
        }
      },
      // Instagramハッシュタグリスト
      {
        name: 'CompaniesSnsInstagramHashtagList',
        path: 'companies/:company_uuid/sns/instagram_hashtag/list',
        component: CompaniesSnsInstagramHashtagList,
        meta: {
          title: i18n.t('pages.companies.instagramHashtag.list.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.snsOauth.title'),
              pathName: 'CompaniesSnsOauth',
              query: {},
            },
            {
              name: i18n.t('pages.companies.instagramHashtag.list.title'),
            }
          ],
        }
      },
      // Instagramハッシュタグ設定画面
      {
        name: 'CompaniesSnsInstagramHashtagCreate',
        path: 'companies/:company_uuid/sns/instagram_hashtag/create',
        component: CompaniesSnsInstagramHashtagForm,
        meta: {
          title: i18n.t('pages.companies.instagramHashtag.list.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.snsOauth.title'),
              pathName: 'CompaniesSnsOauth',
              query: {},
            },
            {
              name: i18n.t('pages.companies.instagramHashtag.list.title'),
              pathName: 'CompaniesSnsInstagramHashtagList',
              query: {},
            },
            {
              name: i18n.t('pages.companies.instagramHashtag.form.title'),
            }
          ],
        }
      },
      // Instagramハッシュタグ設定更新画面
      {
        name: 'CompaniesSnsInstagramHashtagEdit',
        path: 'companies/:company_uuid/sns/instagram_hashtag/:instagram_hash_tag_settings_id/edit',
        component: CompaniesSnsInstagramHashtagForm,
        meta: {
          title: i18n.t('pages.companies.instagramHashtag.list.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.snsOauth.title'),
              pathName: 'CompaniesSnsOauth',
              query: {},
            },
            {
              name: i18n.t('pages.companies.instagramHashtag.list.title'),
              pathName: 'CompaniesSnsInstagramHashtagList',
              query: {},
            },
            {
              name: i18n.t('pages.companies.instagramHashtag.form.title'),
            }
          ],
        }
      },
      // 通知設定
      {
        name: 'CompaniesMailNotificationSetting',
        path: 'companies/:company_uuid/mail_notification_setting',
        component: CompaniesMailNotificationSetting,
        meta: {
          title: i18n.t('pages.companies.mailNotificationSetting.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.mailNotificationSetting.title'),
            },
          ],
        }
      },
      // 利用開始後 Googleマップ連携 ブランド選択
      {
        name: 'CompaniesGMBLinkageBrand',
        path: 'companies/:company_uuid/gmb/brands',
        component: CompaniesGMBLinkageBrand,
      },
      // 利用開始後 Googleマップ連携 店舗選択
      {
        name: 'CompaniesGMBLinkageLocations',
        path: 'companies/:company_uuid/gmb/brands/:brand_id',
        component: CompaniesGMBLinkageLocations,
      },
      // 分析画面
      {
        name: 'CompaniesAnalysisInsight',
        path: 'companies/:company_uuid/analysis/insight',
        component: CompaniesAnalysisInsight,
        meta: {
          title: i18n.t('pages.companies.analysis.insight.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.analysis.insight.title'),
            },
          ],
        }
      },
      // ★の数分析
      {
        name: 'CompaniesAnalysisReviews',
        path: 'companies/:company_uuid/analysis/reviews',
        component: CompaniesAnalysisReviews,
        meta: {
          title: i18n.t('pages.companies.analysis.reviews.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.analysis.reviews.title'),
            },
          ],
        }
      },
      // 口コミ相関分析
      {
        name: 'CompaniesAnalysisScatter',
        path: 'companies/:company_uuid/analysis/scatter',
        component: CompaniesAnalysisScatter,
        meta: {
          title: i18n.t('pages.companies.analysis.scatter.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.analysis.scatter.title'),
            },
          ],
        }
      },
      // 検索クエリ分析
      {
        name: 'CompaniesAnalysisSearchQueries',
        path: 'companies/:company_uuid/analysis/search_queries',
        component: CompaniesAnalysisSearchQueries,
        meta: {
          title: i18n.t('pages.companies.analysis.searchQueries.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
            },
            {
              name: i18n.t('pages.companies.analysis.searchQueries.title'),
            },
          ],
        },
      },
      // ランキング
      {
        name: 'CompaniesAnalysisRanking',
        path: 'companies/:company_uuid/analysis/ranking',
        component: CompaniesAnalysisRanking,
        meta: {
          title: i18n.t('pages.companies.analysis.ranking.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.analysis.ranking.title'),
            },
          ],
        }
      },
      // 口コミAI分析 一覧
      {
        name: 'CompaniesAnalysisQscas',
        path: 'companies/:company_uuid/analysis/qscas',
        component: CompaniesAnalysisQscas,
        meta: {
          title: i18n.t('pages.companies.analysis.qscas.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
            },
            {
              name: i18n.t('pages.companies.analysis.qscas.title'),
            },
          ],
        }
      },
      // 口コミAI分析
      {
        name: 'CompaniesAnalysisQscasDetail',
        path: 'companies/:company_uuid/analysis/qscas/detail',
        component: CompaniesAnalysisQscasDetail,
        meta: {
          title: i18n.t('pages.companies.analysis.qscas.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
            },
            {
              name: i18n.t('pages.companies.analysis.qscas.title'),
            },
          ],
        }
      },
      // 店舗ページアクセス分析
      {
        name: 'CompaniesAnalysisVisitors',
        path: 'companies/:company_uuid/analysis/visitors',
        component: CompaniesAnalysisVisitors,
        meta: {
          title: i18n.t('pages.companies.analysis.visitors.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.analysis.visitors.title'),
            },
          ],
        }
      },
      // キーワード分析
      {
        name: 'CompaniesAnalysisKeywords',
        path: 'companies/:company_uuid/analysis/keywords',
        component: CompaniesAnalysisKeywords,
        meta: {
          title: i18n.t('pages.companies.analysis.keywords.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.analysis.keywords.title'),
            },
          ],
        }
      },
      // アンケート分析
      {
        name: 'CompaniesAnalysisSurveys',
        path: 'companies/:company_uuid/analysis/surveys',
        component: CompaniesAnalysisSurveys,
        meta: {
          title: i18n.t('pages.companies.analysis.surveys.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.analysis.surveys.title'),
            },
          ],
        }
      },
      // アンケート分析詳細
      {
        name: 'CompaniesAnalysisSurveysDetail',
        path: 'companies/:company_uuid/analysis/surveys/detail',
        component: CompaniesAnalysisSurveysDetail,
        meta: {
          title: '',
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.analysis.surveys.title'),
              pathName: 'CompaniesAnalysisSurveys',
            },
            {
              name: i18n.t('pages.companies.analysis.surveys.detail.breadCrumbsTitle'),
            },
          ]
        }
      },
      // アンケート回答一覧
      {
        name: 'CompaniesCustomSurveyAnswers',
        path: 'companies/:company_uuid/custom_surveys/answers',
        component: CompaniesCustomSurveyAnswers,
        meta: {
          title: i18n.t('pages.CompaniesCustomSurveyAnswers.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesCustomSurveyAnswers.title'),
            },
          ],
        }
      },
      // アンケート回答ファイル管理
      {
        name: 'CompaniesCustomSurveyAnswerFiles',
        path: 'companies/:company_uuid/custom_surveys/:custom_survey_id/answer_files',
        component: CompaniesCustomSurveyAnswerFiles,
        meta: {
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesCustomSurveyAnswers.title'),
              pathName: 'CompaniesCustomSurveyAnswers',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesCustomSurveyAnswerFiles.basicTitle'),
            },
          ],
        }
      },
      // 変更ログ
      {
        name: 'CompaniesGMBLocationSyncLogs',
        path: 'companies/:company_uuid/gmb_location_sync_logs',
        component: CompaniesGMBLocationSyncLogs,
        meta: {
          title: i18n.t('pages.CompaniesGMBLocationSyncLogs.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesGMBLocationSyncLogs.title'),
            },
          ],
        }
      },
      // RPAエラーログ
      {
        name: 'CompaniesRpaErrorLogs',
        path: 'companies/:company_uuid/rpa_error_logs',
        component: CompaniesRpaErrorLogs,
        meta: {
          title: i18n.t('pages.CompaniesRpaErrorLogs.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesRpaErrorLogs.title'),
            },
          ],
        }
      },
      // csvダウンロード進捗管理画面
      {
        name: 'CompaniesExportResults',
        path: 'companies/:company_uuid/export/results',
        component: CompaniesExportResults,
        meta: {
          title: i18n.t('pages.CompaniesExportResults.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesExportResults.title'),
            },
          ],
        }
      },
      // プラン変更
      {
        name: 'CompaniesChangePlan',
        path: 'companies/:company_uuid/change_plan',
        component: CompaniesChangePlan,
        meta: {
          title: i18n.t('pages.CompaniesChangePlan.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.paymentSetting.title'),
              pathName: 'PaymentSetting',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesChangePlan.title'),
            },
          ],
        }
      },
      // 電話対応
      {
        name: 'CompaniesTestimonialIndex',
        path: 'companies/:company_uuid/testimonials',
        component: CompaniesTestimonialIndex,
        meta: {
          title: i18n.t('pages.CompaniesTestimonialIndex.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesTestimonialIndex.title'),
            },
          ],
        }
      },
      // 電話対応ファイル管理
      {
        name: 'CompaniesTestimonialFiles',
        path: 'companies/:company_uuid/testimonials/files',
        component: CompaniesTestimonialFiles,
        meta: {
          title: i18n.t('pages.CompaniesTestimonialIndex.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesTestimonialIndex.title'),
              pathName: 'CompaniesTestimonialIndex',
            },
            {
              name: i18n.t('pages.CompaniesTestimonialFiles.title'),
            },
          ],
        }
      },
      // フードメニュー一覧
      {
        name: 'CompaniesFoodMenusIndex',
        path: 'companies/:company_uuid/food_menus',
        component: CompaniesFoodMenusIndex,
        meta: {
          title: i18n.t('pages.CompaniesFoodMenusIndex.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesFoodMenusIndex.title'),
            },
          ],
        }
      },
      // フードメニュー新規
      {
        name: 'CompaniesFoodMenusNew',
        path: 'companies/:company_uuid/food_menus/new',
        component: CompaniesFoodMenusForm,
        meta: {
          title: i18n.t('pages.CompaniesFoodMenusForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesFoodMenusIndex.breadcrumb'),
              pathName: 'CompaniesFoodMenusIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesFoodMenusForm.title'),
            },
          ],
        }
      },
      // フードメニュー追加
      {
        name: 'CompaniesFoodMenusEdit',
        path: 'companies/:company_uuid/food_menus/:id/edit',
        component: CompaniesFoodMenusForm,
        meta: {
          title: i18n.t('pages.CompaniesFoodMenusForm.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesFoodMenusIndex.breadcrumb'),
              pathName: 'CompaniesFoodMenusIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesFoodMenusForm.title'),
            },
          ],
        }
      },
      // フードメニューCSV一覧
      {
        name: 'CompaniesFoodMenusUploadedFiles',
        path: 'companies/:company_uuid/food_menus/food_menu_files',
        component: CompaniesFoodMenusUploadedFiles,
        meta: {
          title: i18n.t('pages.CompaniesFoodMenusUploadedFiles.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesFoodMenusIndex.title'),
              pathName: 'CompaniesFoodMenusIndex',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesFoodMenusUploadedFiles.title'),
            },
          ],
        }
      },
      // 写真ライブラリ一覧
      {
        name: 'CompaniesMediaLibraries',
        path: 'companies/:company_uuid/media_libraries',
        component: CompaniesMediaLibraries,
        meta: {
          title: i18n.t('pages.CompaniesMediaLibraries.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesMediaLibraries.title'),
            },
          ],
        }
      },
      // 写真ライブラリ 写真ライブラリ一括操作
      {
        name: 'CompaniesMediaLibrariesBulkSet',
        path: 'companies/:company_uuid/media_libraries/bulk_set',
        component: CompaniesMediaLibrariesBulkSet,
        meta: {
          title: i18n.t('pages.CompaniesMediaLibrariesBulkSet.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
            },
            {
              name: i18n.t('pages.CompaniesMediaLibraries.title'),
              pathName: 'CompaniesMediaLibraries',
            },
            {
              name: i18n.t('pages.CompaniesMediaLibrariesBulkSet.title'),
            },
          ],
        }
      },
      // 写真詳細
      {
        name: 'CompaniesMediaLibrary',
        path: 'companies/:company_uuid/media_libraries/:id',
        component: CompaniesMediaLibrary,
        meta: {
          title: i18n.t('pages.CompaniesMediaLibrary.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesMediaLibraries.title'),
              pathName: 'CompaniesMediaLibraries',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesMediaLibrary.title'),
            },
          ],
        }
      },
      // 写真アップロード
      {
        name: 'CompaniesMediaLibraryUpload',
        path: 'companies/:company_uuid/media_library/upload',
        component: CompaniesMediaLibraryUpload,
        meta: {
          title: i18n.t('pages.CompaniesMediaLibraryUpload.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesMediaLibraries.title'),
              pathName: 'CompaniesMediaLibraries',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesMediaLibraryUpload.title'),
            },
          ],
        }
      },
      // 商品 新規
      {
        name: 'CompaniesProductNew',
        path: 'companies/:company_uuid/products/new',
        component: CompaniesProductForm,
        meta: {
          title: i18n.t('pages.CompaniesProducts.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesProducts.title'),
              pathName: 'CompaniesProducts',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesProductNew.title'),
            },
          ],
        }
      },
      // 商品 編集
      {
        name: 'CompaniesProductEdit',
        path: 'companies/:company_uuid/products/:id/edit',
        component: CompaniesProductForm,
        meta: {
          title: i18n.t('pages.CompaniesProducts.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesProducts.title'),
              pathName: 'CompaniesProducts',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesProduct.title'),
              pathName: 'CompaniesProduct',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesProductEdit.title')
            }
          ],
        }
      },
      // 商品一覧
      {
        name: 'CompaniesProducts',
        path: 'companies/:company_uuid/products',
        component: CompaniesProducts,
        meta: {
          title: i18n.t('pages.CompaniesProducts.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesProducts.title')
            },
          ],
        }
      },
      // 商品店舗設定
      {
        name: 'CompaniesProductsBulkSet',
        path: 'companies/:company_uuid/products/bulk_set',
        component: CompaniesProductsBulkSet,
        meta: {
          title: i18n.t('pages.CompaniesProductsBulkSet.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesProducts.title'),
              pathName: 'CompaniesProducts',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesProductsBulkSet.title')
            },
          ],
        }
      },
      // 商品 詳細
      {
        name: 'CompaniesProduct',
        path: 'companies/:company_uuid/products/:id',
        component: CompaniesProduct,
        meta: {
          title: i18n.t('pages.CompaniesProduct.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesProducts.title'),
              pathName: 'CompaniesProducts',
              query: {},
            },
            {
              name: i18n.t('pages.CompaniesProduct.title')
            }
          ]
        }
      },
      // サービス一覧画面
      {
        name: 'CompaniesServices',
        path: 'companies/:company_uuid/services',
        component: CompaniesServices,
        meta: {
          title: i18n.t('pages.companies.services.title'),
          breadcrumbs: [
            {
              name: i18n.t('pages.CompaniesDashboards.title'),
              pathName: 'CompaniesDashboards',
              query: {},
            },
            {
              name: i18n.t('pages.companies.services.title'),
            },
          ],
        }
      },
      // サービス作成画面
      {
        name: 'CompaniesServicesNew',
        path: 'companies/:company_uuid/categories/:category_id/services/new',
        component: CompaniesServicesForm,
      },
      // サービス編集画面
      {
        name: 'CompaniesServicesEdit',
        path: 'companies/:company_uuid/categories/:category_id/services/:id/edit',
        component: CompaniesServicesForm,
      }
    ],
  },
  {
    path: '/p',
    component: Public,
    children: [
      {
        // 初回登録 申し込み完了
        name: 'RegistrationsApplyCompleted',
        path: 'companies/registrations/apply_completed',
        component: RegistrationsApplyCompleted
      },
      {
        // 初回登録 申し込み
        name: 'RegistrationsInfo',
        path: 'companies/registrations/info',
        component: RegistrationsInfo
      },
    ]
  },
  // 404
  {
    name: 'Page404',
    path: '/:pathMatch(.*)*',
    component: Page404,
  }
]

export default createRouter({
  history: createWebHistory(),
  routes: routes,
  scrollBehavior() {
    return { top: 0, left: 0 }
  },
})
